// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".steps .icon[data-v-842d6952]{height:2.5rem}.steps h5[data-v-842d6952]{color:#1f2430}.steps p[data-v-842d6952]{max-width:260px}", ""]);
// Exports
module.exports = exports;
